import html from "../lib/html";
import loadingIcon from "../icons/loading.svg?raw";

export default html`
  <div class="loading" name="loading">
    <div class="loading-icon">${loadingIcon}</div>
  </div>
`;
